import React, { useRef } from "react";
import { Upload, Trash2 } from "lucide-react";
import { formatDate } from "./utils";

const ImagesTab = ({
  product,
  images,
  uploadColour,
  setUploadColour,
  uploadGrip,
  setUploadGrip,
  uploading,
  onFileChange,
  onDelete,
}) => {
  const fileInput = useRef(null);
  const onUploadClick = () => fileInput.current?.click();

  return (
    <div data-testid="admin-images-panel">
      <div className="bg-white border border-line p-6 mb-6 flex flex-col md:flex-row md:items-end gap-4">
        <div className="flex-1">
          <p className="overline mb-2">Upload to colourway</p>
          <select
            value={uploadColour}
            onChange={(e) => setUploadColour(e.target.value)}
            className="w-full border border-line px-4 py-3 bg-chalk focus:outline-none focus:border-ink"
            data-testid="admin-upload-colourway-select"
          >
            <option value="">Select a colourway…</option>
            {(product?.colourways || []).map((c) => (
              <option key={c.slug} value={c.slug}>
                {c.name}
              </option>
            ))}
          </select>
        </div>
        <div className="flex-1">
          <p className="overline mb-2">Grip (optional)</p>
          <select
            value={uploadGrip}
            onChange={(e) => setUploadGrip(e.target.value)}
            className="w-full border border-line px-4 py-3 bg-chalk focus:outline-none focus:border-ink"
            data-testid="admin-upload-grip-select"
          >
            <option value="">No grip — colourway hero</option>
            {(product?.grips || []).map((g) => (
              <option key={g.slug} value={g.slug}>
                {g.no} {g.name}
              </option>
            ))}
          </select>
        </div>
        <input
          ref={fileInput}
          type="file"
          accept="image/png,image/jpeg,image/webp"
          hidden
          onChange={onFileChange}
          data-testid="admin-upload-file-input"
        />
        <button
          type="button"
          onClick={onUploadClick}
          disabled={uploading || !uploadColour}
          className="btn-primary disabled:opacity-50"
          data-testid="admin-upload-button"
        >
          <Upload size={14} className="mr-2" />
          {uploading ? "Uploading…" : "Upload image"}
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-px bg-line border border-line">
        {images.length === 0 ? (
          <div className="col-span-full bg-white p-12 text-center text-mute text-sm">
            No uploads yet. Pick a colourway and upload your first product shot.
          </div>
        ) : (
          images.map((img) => (
            <div key={img.id} className="bg-white" data-testid={`admin-image-${img.id}`}>
              <div className="aspect-square border-b border-line overflow-hidden">
                <img src={img.url} alt={img.colourway_slug} className="w-full h-full object-cover" />
              </div>
              <div className="p-3 flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium">{img.colourway_slug}</p>
                  {img.grip_slug && (
                    <p className="mono text-[10px] text-mute">Grip · {img.grip_slug}</p>
                  )}
                  <p className="mono text-[10px] text-mute">{formatDate(img.uploaded_at)}</p>
                </div>
                <button
                  type="button"
                  onClick={() => onDelete(img.id)}
                  className="text-mute hover:text-ink p-1"
                  data-testid={`admin-delete-image-${img.id}`}
                >
                  <Trash2 size={12} />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ImagesTab;
